module.exports = __webpack_public_path__ + "static/media/facebook.55003991.webp";